var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 455.111 455.111" },
      attrs: {
        id: "Capa_1",
        height: "18",
        version: "1.1",
        viewBox: "0 0 455.111 455.111",
        width: "18",
        x: "0px",
        "xml:space": "preserve",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        y: "0px",
      },
    },
    [
      _c("circle", {
        staticStyle: { fill: "#e24c4b" },
        attrs: { cx: "227.556", cy: "227.556", r: "227.556" },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#d1403f" },
        attrs: {
          d: "M455.111,227.556c0,125.156-102.4,227.556-227.556,227.556c-72.533,0-136.533-32.711-177.778-85.333\n\tc38.4,31.289,88.178,49.778,142.222,49.778c125.156,0,227.556-102.4,227.556-227.556c0-54.044-18.489-103.822-49.778-142.222\n\tC422.4,91.022,455.111,155.022,455.111,227.556z",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticStyle: { fill: "#ffffff" },
        attrs: {
          d: "M331.378,331.378c-8.533,8.533-22.756,8.533-31.289,0l-72.533-72.533l-72.533,72.533\n\tc-8.533,8.533-22.756,8.533-31.289,0c-8.533-8.533-8.533-22.756,0-31.289l72.533-72.533l-72.533-72.533\n\tc-8.533-8.533-8.533-22.756,0-31.289c8.533-8.533,22.756-8.533,31.289,0l72.533,72.533l72.533-72.533\n\tc8.533-8.533,22.756-8.533,31.289,0c8.533,8.533,8.533,22.756,0,31.289l-72.533,72.533l72.533,72.533\n\tC339.911,308.622,339.911,322.844,331.378,331.378z",
        },
      }),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
      _vm._v(" "),
      _c("g"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }